import { render, staticRenderFns } from "./ProgramEvolution.vue?vue&type=template&id=d4c33a4a&scoped=true&"
import script from "./ProgramEvolution.vue?vue&type=script&lang=ts&"
export * from "./ProgramEvolution.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramEvolution.vue?vue&type=style&index=0&id=d4c33a4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c33a4a",
  null
  
)

export default component.exports